<template>
    <v-dialog
        v-model="openReminder"
        scrollable
        persistent
        max-width="500px"
        transition="dialog-transition">
        <v-layout>
            <v-flex class="forum-reminder-pop">
                <v-flex class="forum-reminder-pop__details">
                    <v-flex tag="h2">{{ConfidentialityReminder.TITLE}}</v-flex>
                    <v-flex class="head">
                        <v-flex tag="span">{{ConfidentialityReminder.Header_Texts.NOTHING}}</v-flex>
                        <v-flex tag="span">{{ConfidentialityReminder.Header_Texts.NOBODY}}</v-flex>
                        <v-flex tag="span">{{ConfidentialityReminder.Header_Texts.NEVER}}</v-flex>
                    </v-flex>
                    <v-flex class="desc">
                        <v-flex tag="strong">{{ConfidentialityReminder.Header_Texts.NOT_SELECTIVE}}</v-flex>
                        <v-flex tag="p">{{ConfidentialityReminder.Description.NOT_SELECTIVE}}</v-flex>

                        <v-flex tag="strong">{{ConfidentialityReminder.Header_Texts.FOREVER}}</v-flex>
                        <v-flex tag="p">{{ConfidentialityReminder.Description.FOREVER}}</v-flex>

                        <v-flex tag="strong">{{ConfidentialityReminder.Header_Texts.MUTUAL_AGREEMENT}}</v-flex>
                        <v-flex tag="p">{{ConfidentialityReminder.Description.MUTUAL_AGREEMENT}}</v-flex>
                    </v-flex>
                    <v-flex
                        text-xs-right
                        pl-3
                        pb-3
                        pr-3
                        pt-0>
                        <v-btn
                            class="primary_btn"
                            @click="openReminder=false"
                            data-qe-id="chapter-page_open-reminder_btn">
                            {{ConfidentialityReminder.BUTTON}}
                        </v-btn>
                    </v-flex>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-dialog>
</template>

<script>
    import { ConfidentialityReminder } from "../ForumPage/ForumConstants";

    export default {
        name: 'ConfidentialityReminderDialog',
        created() {
            this.openReminder = this.$route.params.communityId !== undefined;
        },
        data: () => ({
            ConfidentialityReminder,
            openReminder: false,
        }),
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';

    //
    //
    //TODO: There are all temporary CSS
    //
    //
    //

    .chapter {
        &__left {
            min-height: 150px;
            background-color: $white;
            border: 1px solid $ypo-medium-gray;
            border-radius: 4px;
            text-align: center;
            font-weight: bold;
            margin-bottom: 15px;
            padding: 15px;
        }

        &__middle {
            min-height: 400px;
        }

        &__right {
            min-height: 150px;
            background-color: $white;
            border: 1px solid $ypo-medium-gray;
            border-radius: 4px;
            text-align: center;
            font-weight: bold;
            margin-bottom: 15px;
            padding: 15px;
        }
    }

    .sponsor {
        font-size: 22px !important;
        font-weight: 400;
        color: $ypo-blue;
    }

    .line-spacing {
        margin-right: 15px;
        margin-left: 15px;
    }

    h3 {
        color: $ypo-blue;
        font-size: 22px;
        letter-spacing: -0.72px;
        line-height: 30px;
        font-weight: 400;
        text-align: left;
    }

    .forum-reminder-pop {
        position: relative;
        background: $white;
        border-radius: 4px;
        width: 600px;

        &__details {
            position: relative;
            background: $white;
            z-index: 11;
            border-radius: 4px;

            .head {
                text-align: center;
                color: $black;
                font-family: Raleway;
                font-size: 14px;
                font-weight: bold;
                line-height: 34px;
                margin-top: 20px;

                span {
                    text-transform: uppercase;
                    position: relative;
                    padding: 3px 25px;

                    &:nth-child(2n) {
                        border-right: 1px solid $ypo-text-border;
                        border-left: 1px solid $ypo-text-border;
                    }
                }
            }
        }

        &:after {
            content: "";
            background: rgba($black, 0.75);
            position: fixed;
            width: 100%;
            height: 100%;
            z-index: 10;
            left: 0;
            top: 0;
        }

        h2 {
            color: $white;
            font-size: 18px;
            font-weight: bold;
            line-height: 22px;
            text-transform: uppercase;
            text-align: center;
            border-radius: 4px 4px 0 0;
            background-color: $ypo_blue;
            padding: 20px 0;
        }

        .desc {
            padding: 20px 30px;
            padding-bottom: 0px;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.5);

            strong {
                color: $ypo_blue;
                margin-bottom: 0px;
                display: block;
            }

            p {
                margin-bottom: 20px;
            }
        }
    }
</style>
